import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo("Page not found");
  return (
    <section className="container-x py-28 text-center">
      <p className="eyebrow text-[#C28B5E]">404</p>
      <h1 className="mt-3 text-4xl sm:text-5xl text-[#1E3B2E]">This page could not be found</h1>
      <Link to="/" className="btn-primary mt-10" data-testid="notfound-home-btn">Return home</Link>
    </section>
  );
}
